// extracted by mini-css-extract-plugin
export default {"channel":"_3A-qi","channelImage":"_3NYPo","channelTitle":"_1UJWD"};